var site = site || {};

(function ($) {
  Drupal.behaviors.compareChartFormatterV1 = {
    initModuleCount: 0,
    initLoad: false,
    $modules: [],
    attach: function (context) {
      var self = this;
      var $modules = $('.js-compare-chart-formatter', context);

      $modules.each(function () {
        var $module = $(this);

        self.getDom($module);
        self.setConfig($module);
        self.attachModule($module);
        self.inlineHeading($module);
        self.columnLink($module);
        self.$modules.push($module);
      });

      $(window)
        .off('resize.compareChartFormatter')
        .on(
          'resize.compareChartFormatter',
          _.debounce(function () {
            // Chrome bug workaround.
            if (self.initLoad) {
              self.$modules.forEach(function ($module) {
                $module.nodes.heading.prependTo($module.nodes.carousel);
                self.getHeights($module, true);
              });
            } else {
              self.initLoad = true;
            }
          }, 100)
        );
    },
    setMaxes: function ($module, $attr, index) {
      var descHeight = 0;
      var descMax = 0;
      var attrHeight = 0;
      var attrMax = 0;
      var maxTotal = 0;

      $module.nodes.descriptions[index].each(function () {
        descHeight = $(this).outerHeight();
        if (descHeight > descMax) {
          descMax = descHeight;
        }
      });
      $attr.each(function () {
        if ($module.config.isHorizontal) {
          attrHeight = $(this).find('.js-mantle-custom-text').outerHeight();
        } else {
          attrHeight = $(this).find('.js-mantle-custom-text').find('p').outerWidth();
        }
        if (attrHeight > attrMax) {
          attrMax = attrHeight;
        }
      });

      if (descMax > attrMax) {
        maxTotal = descMax;
      } else {
        maxTotal = attrMax;
      }

      $module.nodes.descriptions[index].height(maxTotal);
      $module.nodes.attributes[index].height(maxTotal + 2);
    },
    getHeights: function ($module, loaded) {
      var self = this;
      var $title;
      var $itemImg = $module.find('.js-compare-chart-item-img').first().find('img');
      var titleMax = 0;
      var titleHeight = 0;
      var gapHeight = 0;
      var titleInterval;
      var totalPadding;

      titleInterval = setInterval(function () {
        if (titleMax === 0) {
          $module.nodes.titles.each(function () {
            $title = $(this);
            titleHeight = $title.outerHeight(true);
            if (titleHeight > titleMax) {
              titleMax = titleHeight;
            }
          });
        } else {
          totalPadding =
            parseFloat($module.nodes.titles.css('padding-top')) +
            parseFloat($module.nodes.titles.css('padding-bottom'));
          $module.nodes.titles.height(titleMax - totalPadding);
          if (loaded) {
            gapHeight = $itemImg.height() + titleMax;
            $module.nodes.heading.css('marginTop', gapHeight + 'px');
            self.alignArrows($module, true);
          } else {
            $itemImg
              .on('load', function () {
                gapHeight = this.height + titleMax;
                $module.nodes.heading.css('marginTop', gapHeight + 'px');
                self.alignArrows($module);
              })
              .each(function () {
                if (this.complete) {
                  $(this).trigger('load');
                }
              });
          }
          $.each($module.nodes.attributes, function (index) {
            self.setMaxes($module, $(this), index);
          });
          clearInterval(titleInterval);
        }
      }, 1500);
    },
    columnLink: function ($module) {
      var href;

      $module.nodes.items.each(function () {
        href = $(this).find('.js-compare-chart-item-img').data('href');
        if (href) {
          $(this).addClass('compare-chart-item--href');
        }
      });
    },
    attachModule: function ($module) {
      var self = this;
      var $carousel = $module.find('.js-compare-chart-formatter-carousel');
      var defaultColumnSetting = 4;
      var columnSetting;
      var $children;
      var imgInterval;

      $carousel.removeClass('slick-not-needed');
      columnSetting = parseInt($module.data('columns-large') || defaultColumnSetting, 10);
      $children = $('.js-carousel-slide', $carousel);
      if ($children.length > columnSetting || window.innerWidth <= 768) {
        if (!$carousel.hasClass('slick-initialized')) {
          $carousel.on('init', function () {
            $.event.trigger({
              type: 'compare_chart_formatter:slick_init',
              payload: $module
            });
            $module.nodes.heading.prependTo($carousel);
          });
          $carousel.slick({
            slidesToShow: 1.5,
            slidesToScroll: 1,
            mobileFirst: true,
            rtl: site.direction.isRTL,
            infinite: false,
            dots: false,
            nextArrow: '<img class="slick-next" src=' + $module.data('right-arrow') + '></img>',
            prevArrow: '<img class="slick-prev" src=' + $module.data('left-arrow') + '></img>',
            responsive: [
              {
                breakpoint: 960,
                settings: {
                  slidesToShow: columnSetting
                }
              }
            ]
          });
          imgInterval = setInterval(function () {
            if ($carousel.hasClass('slick-initialized')) {
              self.getHeights($module);
              clearInterval(imgInterval);
            }
          }, 1500);
          $carousel.on('reInit', function () {
            $module.nodes.heading.prependTo($carousel);
          });
        } else {
          self.getHeights($module);
        }
      } else {
        if ($carousel.hasClass('slick-initialized')) {
          try {
            $carousel.slick('destroy');
          } catch (e) {
            console.error(e);
          }
        }
        $carousel.addClass('slick-not-needed');
        $module.nodes.heading.prependTo($carousel);
        self.getHeights($module);
      }
      if (window.innerWidth <= 768) {
        $carousel.on('init', function () {
          $module.nodes.heading.prependTo($carousel);
        });
      }
      $module.nodes.items.once().on('click', function () {
        var href = $(this).find('.js-compare-chart-item-img').data('href');
        if (href) {
          window.location = href;
          return false;
        }
      });
    },
    addHeadings: function ($module) {
      $module.nodes.heading.prependTo($module.nodes.carousel);
    },
    alignArrows: function ($module, loaded) {
      var $carousel = $module.nodes.carousel;
      var $arrowAlignmentContainer = $carousel.find('.slick-active .js-compare-chart-item-img');
      var $arrows = $carousel.find('.slick-arrow');
      var $prevArrow = $carousel.find('.slick-prev.slick-arrow');

      if ($arrowAlignmentContainer.length > 0 && $prevArrow.length > 0) {
        if (loaded) {
          $arrows.css({
            top: $arrowAlignmentContainer.height() / 2 - $prevArrow.height() / 2
          });
        } else {
          $prevArrow
            .on('load', function () {
              $arrows.css({
                top: $arrowAlignmentContainer.height() / 2 - $prevArrow.height() / 2
              });
            })
            .each(function () {
              if (this.complete) {
                $(this).trigger('load');
              }
            });
        }
      }
    },
    inlineHeading: function ($module) {
      var $headings = $module.find('.js-compare-chart-formatter-headings');
      var i;

      if ($headings.hasClass('js-compare-chart-formatter__headings--inline')) {
        for (i = 1; i < 6; i++) {
          $headings.find('.js-compare-chart-formatter-headings-title--' + i).each(function () {
            $module
              .find('.js-compare-chart-item-text-heading--' + i)
              .html($headings.find('.js-compare-chart-formatter-headings-title--' + i).html());
          });
        }
        $module
          .find('.js-compare-chart-formatter--chart')
          .addClass('compare-chart-formatter__chart--inline');
      }
    },
    setConfig: function ($module) {
      $module.config = {};
      $module.config.isHorizontal = $module.hasClass('js-compare-chart-formatter__headings--horz');
    },
    getDom: function ($module) {
      $module.nodes = {};
      $module.nodes.items = $('.js-compare-chart-item', $module);
      $module.nodes.titles = $('.js-compare-chart-item-text-title', $module);
      $module.nodes.heading = $('.js-compare-chart-formatter-headings', $module);
      $module.nodes.carousel = $('.js-compare-chart-formatter-carousel', $module);
      $module.nodes.descriptionOne = $('.js-compare-chart-item-text-description--1', $module);
      $module.nodes.descriptionTwo = $('.js-compare-chart-item-text-description--2', $module);
      $module.nodes.descriptionThree = $('.js-compare-chart-item-text-description--3', $module);
      $module.nodes.descriptionFour = $('.js-compare-chart-item-text-description--4', $module);
      $module.nodes.descriptionFive = $('.js-compare-chart-item-text-description--5', $module);
      $module.nodes.descriptions = [
        $module.nodes.descriptionOne,
        $module.nodes.descriptionTwo,
        $module.nodes.descriptionThree,
        $module.nodes.descriptionFour,
        $module.nodes.descriptionFive
      ];
      $module.nodes.attrOne = $('.js-compare-chart-formatter-headings-title--1', $module);
      $module.nodes.attrTwo = $('.js-compare-chart-formatter-headings-title--2', $module);
      $module.nodes.attrThree = $('.js-compare-chart-formatter-headings-title--3', $module);
      $module.nodes.attrFour = $('.js-compare-chart-formatter-headings-title--4', $module);
      $module.nodes.attrFive = $('.js-compare-chart-formatter-headings-title--5', $module);
      $module.nodes.attributes = [
        $module.nodes.attrOne,
        $module.nodes.attrTwo,
        $module.nodes.attrThree,
        $module.nodes.attrFour,
        $module.nodes.attrFive
      ];
    }
  };
})(jQuery);
